import { lazy } from 'react'

export const lazyWithPrefetch = (
  factory: () => Promise<{ default: React.ComponentType<any> }>
): React.LazyExoticComponent<React.ComponentType<any>> => {
  factory()
  return lazy(factory)
}
